import React from 'react'
import { checkIcon } from '../../assets'
import styles from './styles.module.css'

const WhyCirclePlug = ({ reason }) => {
  return (
    <div className={styles.reasoncontainer}>
      <span className={styles.checkbox}>{checkIcon}</span>
      <p className={styles.reason}>{reason}</p>
    </div>
  )
}

export default WhyCirclePlug
